// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var RescriptRelay_Mutation = require("rescript-relay/src/RescriptRelay_Mutation.bs.js");
var ConversationConversationsSectionCommon_InitiatePropertyConversationMutation_graphql = require("../../../__generated__/ConversationConversationsSectionCommon_InitiatePropertyConversationMutation_graphql.bs.js");
var ConversationConversationsSectionCommon_InitiateBuyerNeedConversationMutation_graphql = require("../../../__generated__/ConversationConversationsSectionCommon_InitiateBuyerNeedConversationMutation_graphql.bs.js");
var ConversationConversationsSectionCommon_InitiateRentalNeedConversationMutation_graphql = require("../../../__generated__/ConversationConversationsSectionCommon_InitiateRentalNeedConversationMutation_graphql.bs.js");
var ConversationConversationsSectionCommon_InitiateMessageBroadcastConversationMutation_graphql = require("../../../__generated__/ConversationConversationsSectionCommon_InitiateMessageBroadcastConversationMutation_graphql.bs.js");

var convertVariables = ConversationConversationsSectionCommon_InitiatePropertyConversationMutation_graphql.Internal.convertVariables;

var convertResponse = ConversationConversationsSectionCommon_InitiatePropertyConversationMutation_graphql.Internal.convertResponse;

var convertWrapRawResponse = ConversationConversationsSectionCommon_InitiatePropertyConversationMutation_graphql.Internal.convertWrapRawResponse;

var commitMutation = RescriptRelay_Mutation.commitMutation(convertVariables, ConversationConversationsSectionCommon_InitiatePropertyConversationMutation_graphql.node, convertResponse, convertWrapRawResponse);

var use = RescriptRelay_Mutation.useMutation(convertVariables, ConversationConversationsSectionCommon_InitiatePropertyConversationMutation_graphql.node, convertResponse, convertWrapRawResponse);

var InitiatePropertyConversationMutation = {
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapRawResponse,
  commitMutation: commitMutation,
  use: use
};

var convertVariables$1 = ConversationConversationsSectionCommon_InitiateMessageBroadcastConversationMutation_graphql.Internal.convertVariables;

var convertResponse$1 = ConversationConversationsSectionCommon_InitiateMessageBroadcastConversationMutation_graphql.Internal.convertResponse;

var convertWrapRawResponse$1 = ConversationConversationsSectionCommon_InitiateMessageBroadcastConversationMutation_graphql.Internal.convertWrapRawResponse;

var commitMutation$1 = RescriptRelay_Mutation.commitMutation(convertVariables$1, ConversationConversationsSectionCommon_InitiateMessageBroadcastConversationMutation_graphql.node, convertResponse$1, convertWrapRawResponse$1);

var use$1 = RescriptRelay_Mutation.useMutation(convertVariables$1, ConversationConversationsSectionCommon_InitiateMessageBroadcastConversationMutation_graphql.node, convertResponse$1, convertWrapRawResponse$1);

var InitiateMessageBroadcastConversationMutation_conversationVisibilityV5_decode = ConversationConversationsSectionCommon_InitiateMessageBroadcastConversationMutation_graphql.Utils.conversationVisibilityV5_decode;

var InitiateMessageBroadcastConversationMutation_conversationVisibilityV5_fromString = ConversationConversationsSectionCommon_InitiateMessageBroadcastConversationMutation_graphql.Utils.conversationVisibilityV5_fromString;

var InitiateMessageBroadcastConversationMutation = {
  conversationVisibilityV5_decode: InitiateMessageBroadcastConversationMutation_conversationVisibilityV5_decode,
  conversationVisibilityV5_fromString: InitiateMessageBroadcastConversationMutation_conversationVisibilityV5_fromString,
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables$1,
  convertResponse: convertResponse$1,
  convertWrapRawResponse: convertWrapRawResponse$1,
  commitMutation: commitMutation$1,
  use: use$1
};

var convertVariables$2 = ConversationConversationsSectionCommon_InitiateRentalNeedConversationMutation_graphql.Internal.convertVariables;

var convertResponse$2 = ConversationConversationsSectionCommon_InitiateRentalNeedConversationMutation_graphql.Internal.convertResponse;

var convertWrapRawResponse$2 = ConversationConversationsSectionCommon_InitiateRentalNeedConversationMutation_graphql.Internal.convertWrapRawResponse;

var commitMutation$2 = RescriptRelay_Mutation.commitMutation(convertVariables$2, ConversationConversationsSectionCommon_InitiateRentalNeedConversationMutation_graphql.node, convertResponse$2, convertWrapRawResponse$2);

var use$2 = RescriptRelay_Mutation.useMutation(convertVariables$2, ConversationConversationsSectionCommon_InitiateRentalNeedConversationMutation_graphql.node, convertResponse$2, convertWrapRawResponse$2);

var InitiateRentalNeedConversationMutation = {
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables$2,
  convertResponse: convertResponse$2,
  convertWrapRawResponse: convertWrapRawResponse$2,
  commitMutation: commitMutation$2,
  use: use$2
};

var convertVariables$3 = ConversationConversationsSectionCommon_InitiateBuyerNeedConversationMutation_graphql.Internal.convertVariables;

var convertResponse$3 = ConversationConversationsSectionCommon_InitiateBuyerNeedConversationMutation_graphql.Internal.convertResponse;

var convertWrapRawResponse$3 = ConversationConversationsSectionCommon_InitiateBuyerNeedConversationMutation_graphql.Internal.convertWrapRawResponse;

var commitMutation$3 = RescriptRelay_Mutation.commitMutation(convertVariables$3, ConversationConversationsSectionCommon_InitiateBuyerNeedConversationMutation_graphql.node, convertResponse$3, convertWrapRawResponse$3);

var use$3 = RescriptRelay_Mutation.useMutation(convertVariables$3, ConversationConversationsSectionCommon_InitiateBuyerNeedConversationMutation_graphql.node, convertResponse$3, convertWrapRawResponse$3);

var InitiateBuyerNeedConversationMutation = {
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables$3,
  convertResponse: convertResponse$3,
  convertWrapRawResponse: convertWrapRawResponse$3,
  commitMutation: commitMutation$3,
  use: use$3
};

function attachmentToInput(attachment) {
  return {
          contentType: attachment.contentType,
          fileName: attachment.fileName,
          id: attachment.id,
          key: attachment.key
        };
}

exports.InitiatePropertyConversationMutation = InitiatePropertyConversationMutation;
exports.InitiateMessageBroadcastConversationMutation = InitiateMessageBroadcastConversationMutation;
exports.InitiateRentalNeedConversationMutation = InitiateRentalNeedConversationMutation;
exports.InitiateBuyerNeedConversationMutation = InitiateBuyerNeedConversationMutation;
exports.attachmentToInput = attachmentToInput;
/* commitMutation Not a pure module */
